// extracted by mini-css-extract-plugin
export default {"root":"Input_root__qzR6h","label":"Input_label__NXpCD","input":"Input_input__E5rzA","errorInput":"Input_errorInput__Bna12","errorText":"Input_errorText__iicJ1"};